import lrsAdapter from '../../helpers/lrs_adapter'
import getAxiosInstance from '../../helpers/get_axios_instance'

class Token {
  static tokenIntrospect (token) {
    const axios = getAxiosInstance()

    const promise = axios.get(`getTokenData?r={"token": "${token}"}`)
    return promise.then(lrsAdapter, lrsAdapter).then(result => result.data[0])
  }
}

export default Token
